import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import SeoSchema from '@/components/feature/SeoSchema';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategorySection from './components/CategorySection';
import FeatureCards from './components/FeatureCards';
import ComparisonTable from './components/ComparisonTable';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ArticleSection from './components/ArticleSection';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://itaobuyspread.skin';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet Italia',
  url: siteUrl,
  description: 'Guida italiana completa su Itaobuy Spreadsheet: recensioni, tutorial, sicurezza e confronti.',
  inLanguage: 'it',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: "Cos'è Itaobuy Spreadsheet?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Itaobuy Spreadsheet è una piattaforma moderna che combina funzionalità di foglio di calcolo con strumenti avanzati di gestione dati. Progettata per utenti di ogni livello, offre un'interfaccia intuitiva per organizzare, analizzare e condividere informazioni in modo efficiente.",
      },
    },
    {
      '@type': 'Question',
      name: 'Itaobuy Spreadsheet è sicuro?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Sì, la sicurezza dei dati è una priorità assoluta per itaobuy sheet. La piattaforma utilizza crittografia avanzata per proteggere le tue informazioni, sistemi di backup automatici e controlli di accesso granulari.",
      },
    },
    {
      '@type': 'Question',
      name: 'Come utilizzare Itaobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Utilizzare itaobuy sheet è semplice e intuitivo. Dopo aver effettuato l'accesso alla piattaforma, puoi creare nuovi fogli di calcolo, importare dati esistenti o partire da uno dei numerosi template disponibili.",
      },
    },
    {
      '@type': 'Question',
      name: 'Quali sono le alternative a Itaobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Le principali alternative a itaobuy sheet includono Microsoft Excel e Google Sheets. Excel offre funzionalità avanzate ma ha un costo di licenza. Google Sheets è gratuito e basato sul cloud. Itaobuy Spreadsheet combina la potenza di Excel con la praticità cloud di Google Sheets.',
      },
    },
    {
      '@type': 'Question',
      name: 'Dove trovare informazioni aggiornate su Itaobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Puoi trovare informazioni aggiornate su itaobuy sheet visitando il sito ufficiale e consultando le nostre guide e recensioni. Ti consigliamo di visitare regolarmente il nostro sito per rimanere aggiornato sulle ultime novità.',
      },
    },
    {
      '@type': 'Question',
      name: 'Itaobuy Spreadsheet ha un costo?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Itaobuy sheet offre diverse opzioni per soddisfare le esigenze di ogni utente. Sono disponibili piani gratuiti con funzionalità base e piani premium con strumenti avanzati, maggiore spazio di archiviazione e supporto prioritario.',
      },
    },
  ],
};

export default function Home() {
  const [categoryOpen, setCategoryOpen] = useState(false);

  return (
    <>
      <SeoSchema data={websiteSchema} />
      <SeoSchema data={faqSchema} />
      <Navbar onCategoryClick={() => setCategoryOpen(true)} />
      <CategoryDropdown isOpen={categoryOpen} onClose={() => setCategoryOpen(false)} />

      <main>
        <HeroSection />
        <AboutSection onCategoryClick={() => setCategoryOpen(true)} />
        <CategorySection />
        <FeatureCards />
        <ComparisonTable />
        <FAQSection />
        <ArticleSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}